import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { LenticMark } from '../components/LenticMark';
import { EYEBROW } from '../components/site/Band';
import { Library } from '../components/site/Library';
import { ProductionDetail } from '../components/site/ProductionDetail';
import { SessionTrace } from '../components/site/SessionTrace';
export function Methodology() {
  return <>
      <section className="relative w-full overflow-hidden border-b border-mist bg-bone" data-id="element-484" data-mp="3ak0sdt6cqv8u">
        <div className="pointer-events-none absolute -right-40 -top-32 opacity-[0.12] lg:-right-20" data-id="element-485" data-mp="3fic2m50k77rl">
          <LenticMark size={560} title={null} data-id="element-486" data-mp="3k9kdl5hjf16v" />
        </div>

        <div className="relative mx-auto w-full max-w-6xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-487" data-mp="3ka3sedbw59go">
          <p className={`${EYEBROW} text-teal`} data-id="element-488" data-mp="3oadwtlk1brtf">Methodology</p>
          <h1 className="mt-5 max-w-3xl font-display text-[32px] font-light leading-[1.05] tracking-tight text-ink sm:text-[46px] lg:text-[56px]" data-id="element-489" data-mp="3tary8kr4s3ih">
            How a scenario is built, and how we know it still works.
          </h1>
          <p className="mt-8 max-w-[68ch] text-lg leading-relaxed text-graphite sm:text-xl" data-id="element-490" data-mp="357u5uznockjf">
            The construction detail behind the assessment: the archetype
            primitives a scenario is assembled from, the safeguards that stop
            the set becoming a checklist, and the version discipline that makes
            a result reconstructable a year later.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-491" data-mp="3nvh2gfg4s6vj">
            <a href="/#how" className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-6 py-3.5 text-base font-semibold text-ink transition-colors hover:border-ink/40" data-id="element-492" data-mp="3junejm2ous2n">
              How the session works
            </a>
            <a href="/#record" className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-6 py-3.5 text-base font-semibold text-ink transition-colors hover:border-ink/40" data-id="element-493" data-mp="bfdhwthkif29">
              What the record contains
            </a>
          </div>
        </div>
      </section>

      <SessionTrace data-id="element-494" data-mp="uixcyfr3frfa" />

      <ProductionDetail data-id="element-495" data-mp="ujgxm484otx0" />

      <Library data-id="element-496" data-mp="ultcu9mi4q6d" />

      <section className="w-full border-b border-mist bg-bone" data-id="element-497" data-mp="gstwk5ewarxr">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-6 py-16 lg:flex-row lg:items-center lg:justify-between lg:px-10 lg:py-20" data-id="element-498" data-mp="gsbv8uddlniz">
          <p className="max-w-[60ch] font-display text-2xl font-light leading-snug text-ink" data-id="element-499" data-mp="6tuy1fnugcoh">
            Scores are comparable within a locked library version, and we do not
            present them as comparable across versions or roles.
          </p>
          <a href="/#contact" className="inline-flex shrink-0 items-center gap-2 rounded-full bg-ink px-7 py-4 text-base font-semibold text-bone transition-colors hover:bg-teal" data-id="element-500" data-mp="3u16s7lnkb6lq">
            See pilot pricing
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-501" data-mp="1w9uap6qo8k8v" />
          </a>
        </div>
      </section>
    </>;
}